import { Box, Popover, Card } from "@mui/material";

import ActiveFilters from "../../../../Components/filters/ActiveFilters";
import FilterItems from "./FilterItems";

// Delivery Date From/To is hidden for these statuses - keep in sync with
// FilterItems.js's DELIVERY_DATE_HIDDEN_TABS.
const DELIVERY_DATE_HIDDEN_TABS = [
  "waitingQueue",
  "inProgress",
  "paused",
  "loaded",
  "unload",
];

const Filter = ({
  filterOpen,
  filterAnchorEl,
  onCloseFilter,
  filterData,
  handleChangeFilter,
  handleFilter,
  handleClearFilters,
  handleRemove,
  submittedData,
  drivers,
  driverFilterLocked = false,
  lockedDriverName = "",
  activeTab,
  orderStatuses = [],
}) => {
  // Get readable driver name from ID
  const getDriverName = (driverId) => {
    if (!driverId) return "";
    const driver = drivers.find((d) => d.driver_id === driverId);
    return driver ? driver.full_name : driverId;
  };

  const getStatusName = (statusCode) => {
    if (!statusCode) return "";
    const status = orderStatuses.find((s) => s.code === statusCode);
    return status ? status.name : statusCode;
  };

  const activeFilterDefinitions = [
    {
      type: "standard",
      id: "invoice_number",
      label: "Invoice No",
      value: submittedData.invoice_number,
    },
    {
      type: "standard",
      id: "jobNo",
      label: "Job No",
      value: submittedData.jobNo,
    },
    {
      type: "standard",
      id: "customer",
      label: "Customer",
      value: submittedData.customer,
    },
    {
      type: "standard",
      id: "driver_id",
      label: "Driver",
      value: driverFilterLocked
        ? lockedDriverName
        : getDriverName(submittedData.driver_id),
      removable: !driverFilterLocked,
    },
    ...(activeTab === "overview"
      ? [
          {
            type: "standard",
            id: "status",
            label: "Status",
            value: getStatusName(submittedData.status),
          },
        ]
      : []),
    // {
    //   type: "standard",
    //   id: "orderDateStart",
    //   label: "Order Date Start",
    //   value: submittedData.orderDateStart,
    // },
    // {
    //   type: "standard",
    //   id: "orderDateEnd",
    //   label: "Order Date End",
    //   value: submittedData.orderDateEnd,
    // },

    {
      type: "standard",
      id: "invoiceDateStart",
      label: "Invoice Date From",
      value: submittedData.invoiceDateStart,
    },
    {
      type: "standard",
      id: "invoiceDateEnd",
      label: "Invoice Date To",
      value: submittedData.invoiceDateEnd,
    },
    ...(!DELIVERY_DATE_HIDDEN_TABS.includes(activeTab)
      ? [
          {
            type: "standard",
            id: "deliveryDateStart",
            label: "Delivery Date From",
            value: submittedData.deliveryDateStart,
          },
          {
            type: "standard",
            id: "deliveryDateEnd",
            label: "Delivery Date To",
            value: submittedData.deliveryDateEnd,
          },
        ]
      : []),
    ...(activeTab === "delivered"
      ? [
          {
            type: "standard",
            id: "deliveredDateStart",
            label: "Delivered From",
            value: submittedData.deliveredDateStart,
          },
          {
            type: "standard",
            id: "deliveredDateEnd",
            label: "Delivered To",
            value: submittedData.deliveredDateEnd,
          },
        ]
      : []),
  ];

  return (
    <>
      <Popover
        open={filterOpen}
        anchorEl={filterAnchorEl}
        onClose={onCloseFilter}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        slotProps={{
          paper: {
            sx: {
              mt: 1,
              borderRadius: "10px",
              boxShadow: "0 10px 30px rgba(15, 23, 42, 0.14)",
              border: "1px solid #E5E7EB",
              width: { xs: "calc(100vw - 32px)", sm: 880 },
              maxWidth: "calc(100vw - 32px)",
            },
          },
        }}
      >
        <Card elevation={0} sx={{ borderRadius: 0 }}>
          <Box p={{ xs: 2, sm: 2.5 }}>
            <FilterItems
              filterData={filterData}
              handleChangeFilter={handleChangeFilter}
              handleFilter={handleFilter}
              handleClearFilters={handleClearFilters}
              drivers={drivers}
              activeTab={activeTab}
              orderStatuses={orderStatuses}
            />
          </Box>
        </Card>
      </Popover>

      <ActiveFilters
        filterDefinitions={activeFilterDefinitions}
        onRemoveFilter={handleRemove}
      />
    </>
  );
};

export default Filter;
